import React from 'react';
import PropTypes from 'prop-types';

import RestoreIcon from '@mui/icons-material/Restore';
import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import table from '../../../../commonStyles/tables.module.css';
import tableRow from './bmi.module.css';

const BMIRow = ({
    row,
    isDisabled,
    isDeleteDisabled,
    onEdit,
    onDelete,
    isAuditable,
    onSearchAuditItems
}) => {

    return (
        <TableRow hover className={table.basicRowStripes}>
            <TableCell>{formatDate(row.eventDate)}</TableCell>
            <TableCell>
                <div>
                    <span className={tableRow.alignRow}>{row.height}</span>
                    {isAuditable && (
                        <span className={table.auditIcon}>
                            <RestoreIcon
                                onClick={(e) =>
                                    onSearchAuditItems(e, row.id, 'BMI', 'Height', 'bmi')
                                }
                            />
                        </span>
                    )}
                </div>
            </TableCell>
            <TableCell>
                <div>
                    <span className={tableRow.alignRow}>{row.weight}</span>
                    {isAuditable && (
                        <span className={table.auditIcon}>
                            <RestoreIcon
                                onClick={(e) =>
                                    onSearchAuditItems(e, row.id, 'BMI', 'Weight', 'bmi')
                                }
                            />
                        </span>
                    )}
                </div>
            </TableCell>
            <TableCell>
                <span className={tableRow.alignRow}>{row.lost}</span>
            </TableCell>
            <TableCell>{row.bmi}</TableCell>
            <TableCell>{row.measurement || <span className={tableRow.alignEmptyRow}> - </span>}</TableCell>
            <TableCell>{row.event || <span className={tableRow.alignEmptyEvent}> - </span>}</TableCell>
            <TableCell>
                <span className={`${!row.linkedModule ? tableRow.alignLinkRow : ''}`}>
                    {row.linkedModule ?? ' - '}
                </span>
            </TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
            </TableCell>
            <TableCell align="right">
                <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
            </TableCell>
        </TableRow>
    );
};

BMIRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func
};

export default BMIRow;
